import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { createState, fetchStates } from "../../store/slices/locationSlice";

const StateCreatePopup = ({ show, onHide, onSuccess, selectedCountryId }) => {
  const dispatch = useDispatch();

  const { countries = [] } = useSelector((state) => state.location);

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    countryId: selectedCountryId || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (selectedCountryId) {
      setFormData((prev) => ({
        ...prev,
        countryId: selectedCountryId,
      }));
    }
  }, [selectedCountryId]);

  const handleSubmit = async () => {
    if (!formData.name || !formData.countryId) {
      return;
    }

    try {
      setLoading(true);

      await dispatch(
        createState({
          name: formData.name,
          countryId: Number(formData.countryId),
        }),
      ).unwrap();

      // REFRESH STATES
      const refreshed = await dispatch(
        fetchStates(Number(formData.countryId)),
      ).unwrap();

      // FIND NEW STATE
      const latestState = refreshed?.find((x) => x.name === formData.name);

      if (latestState && onSuccess) {
        onSuccess(latestState);
      }

      setFormData({
        name: "",
        countryId: "",
      });

      onHide();
    } catch (error) {
      console.error("Create State Error =>", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add State</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* COUNTRY */}
        <div className="form_group mb-3">
          <label>Country</label>

          <select
            className="form-control"
            name="countryId"
            value={formData.countryId}
            onChange={handleChange}
          >
            <option value="">Select Country</option>

            {countries.map((country) => (
              <option key={country.id} value={country.id}>
                {country.name}
              </option>
            ))}
          </select>
        </div>

        {/* STATE NAME */}
        <div className="form_group mb-3">
          <label>State Name</label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter state name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn_secondary" onClick={onHide}>
          Cancel
        </button>

        <button
          className="btn_primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default StateCreatePopup;
